export default "__VITE_ASSET__49dddaf7__"